import React from 'react';
import { ChevronDown, Pin, Pencil, Sparkles } from 'lucide-react';
import type { GroupKey } from './deriveGroup';

export interface ContentListGroupHeaderProps {
  group: GroupKey;
  count: number;
}

const GROUP_META: Record<
  GroupKey,
  { label: string; accent: string; hint: string | null; icon: React.ReactNode }
> = {
  pinned: {
    label: 'Pinned',
    accent: 'var(--color-coral)',
    hint: 'high-priority work',
    icon: <Pin size={16} strokeWidth={1.75} />,
  },
  progress: {
    label: 'In Progress',
    accent: 'var(--color-ink-2)',
    hint: null,
    icon: <Pencil size={16} strokeWidth={1.75} />,
  },
  queue: {
    label: 'Backlog',
    accent: 'var(--color-ink-3)',
    hint: 'ideas to commit to',
    icon: <Sparkles size={16} strokeWidth={1.75} />,
  },
};

export const ContentListGroupHeader: React.FC<ContentListGroupHeaderProps> = ({
  group,
  count,
}) => {
  const meta = GROUP_META[group];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 28px',
        background: 'var(--color-warm-bg)',
        borderTop: '1px solid var(--color-warm-border)',
        borderBottom: '1px solid var(--color-warm-border)',
        position: 'sticky',
        top: 36,
        zIndex: 1,
      }}
    >
      <span style={{ display: 'inline-flex', color: meta.accent }}>{meta.icon}</span>
      <span
        style={{
          fontSize: 11.5,
          fontWeight: 700,
          color: 'var(--color-ink)',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        {meta.label}
      </span>
      <span
        style={{
          padding: '1px 7px',
          borderRadius: 9,
          background: 'var(--color-paper-2)',
          color: 'var(--color-ink-2)',
          fontSize: 10.5,
          fontWeight: 700,
        }}
      >
        {count}
      </span>
      {meta.hint && (
        <span style={{ fontSize: 11, color: 'var(--color-ink-3)', fontWeight: 500 }}>
          {meta.hint}
        </span>
      )}
      <div style={{ flex: 1 }} />
      <ChevronDown size={16} strokeWidth={1.75} color="var(--color-ink-3)" />
    </div>
  );
};

export default ContentListGroupHeader;
